import { render } from "./ModalDivision.vue?vue&type=template&id=1f832bbc"
import script from "./ModalDivision.vue?vue&type=script&lang=js"
export * from "./ModalDivision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__